import { $ } from '@/Engine/state';
import { PerforatedPanel } from '@/Engine/Wardrobe/PerforatedPanel';
import { updatePartsForAllShelves } from '@/Engine/eventHandlers/lib/shelfDocking';



export function markCollisions() {
    $.wardrobe.shelves.forEach((shelf)=>{
        shelf.setColor(shelf.color);
        // shelf.checkRackCollisions();
    });
    updatePartsForAllShelves();
    $.wardrobe.rackModules.forEach((module)=>{
       module.checkRackCollisions();
    });
    $.wardrobe.shelves.forEach((shelf)=>{

        shelf.checkCollisions();
        // shelf.setColor(shelf.color);
        // if (shelf.type === 'panel') {
        //     const panel = shelf as PerforatedPanel;
        //     panel.checkCollisions();
        // }
        // shelf.checkRackCollisions();
    });
}
